$(document).ready(function () {
  /*
   * checkbox checked
   */
  $(document).on("click", ".chkboxpop.none", function (e) {
    e.preventDefault();
    $(this).addClass("active");
    $(this).removeClass("none");
    $("button.block-right.agree").addClass("active");
    if ($(".block-right.agree.active")[0]) {
      $(".block-right.agree.active").removeAttr("disabled");
    }
  });

  $(document).on("click", ".chkboxpop.active", function (e) {
    e.preventDefault();
    $(this).addClass("none");
    $(this).removeClass("active");
    $("button.block-right.agree").removeClass("active");
    $(".block-right.agree.none").attr("disabled", "disabled");
  });

  setInterval(function () {
    if ($("button.block-right.agree.active")[0]) {
      $("button.block-right.agree.active").removeAttr("diabled");
    } else {
      $("button.block-right.agree").attr("diabled", "disabled");
    }
  }, 1000);

  var imagep = document.getElementById("image_cropped_preview");

  /*
   * customize button
   */
  $(document).on("click", ".customise_button", function () {
    $('.gallery_name_front').html('');
    $('.gallery_name_back').html('');
    if ($(".main_wine")[0]) {
      $(".inner_logo_designs_content").removeClass("active");
         $('.family').addClass('hide');
    $('.back_family').addClass('hide');
      $(".animal").addClass("hide");
      $(".line").addClass("hide");
      $(".sports").addClass("hide");
      $(".travel").addClass("hide");
      $(".nature").addClass("hide");
      $(".weekend").addClass("hide");
      $(".back_sports").addClass("hide");
      $(".back_image").addClass("active");
      $("#inverseCheckbox").prop("checked", false);
      $("#backinverseCheckbox").prop("checked", false);
      $("#inverseCheckbox").attr("disabled", "disabled");
      $("#backinverseCheckbox").attr("disabled", "disabled");
      $(".inverse_color").css("display", "none");
      $(".s1").css("display", "none");
      $(".s1").css("display", "none");
      $("#inverseCheckbox").css("display", "none");
      $("#backinverseCheckbox").css("display", "none");
      $(".left_image_customize").removeClass("both_textactive");
      var leftbox = $(".popup_box .eleft_image_customize").html();
      var rghtbox = $(".popup_box .eright_section_cutomise").html();
      $("body").addClass("customizer_active");
      $(".popup_pd_customizer").addClass("active");
      $(".upprrig").html(rghtbox);
      var checkval = $(".js-color-swatch:checked").val();
      var colo = checkval
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
      console.log(colo);
      $("." + colo).trigger("click");

      var variant_iid = $(".sw_" + colo).attr("data-varinatid");
      $(".variant_id").attr("data-variant", variant_iid);
      $(".uploadingimg").removeAttr("src");
      $(".logo_img_gal").attr("src", "");
      $(".text_uploaded .cstm_textup").html("");
      $(".addtocart_box").addClass("hide");
      $(".edit_front_tab").addClass("hide");
      $(".edit_back_tab").addClass("hide");
      $(".edit_front_tab").removeClass("active");
      $(".edit_back_tab").removeClass("active");

      $(".front_tab").removeClass("hide");
      $(".front_tab").removeClass("active");
      $(".back_tab").addClass("active");
      $(".back_tab").removeClass("hide");
      $(".text_ctent").html("");
      $("#design-text").val("");
      $(".inner_text_design_content").removeClass("active");
      $(".left_image_customize").removeClass("both_active");

      $(".font_sstyle_front").html("");
      $(".font_sstyle_back").html("");
      $(".front_image_url").html("");
      $(".back_image_url").html("");
      $(".front_uploaded_content").html("");
      $(".back_uploaded_content").html("");
      $(".downloadhtml").removeAttr("href");
      $(".downloadhtml").removeAttr("download");

      $(".font_items").removeClass("active");
      $(".font_items.font-Roboto").addClass("active");
      $("#customize_chk-label").removeClass("active");
      $(".block-right").removeClass("active");
      $("#customize_chk-label").addClass("none");
      $(".block-right").attr("disabled", "disabled");

      $(".front_image .cstm_textup").removeClass(
        "font-Socialist font-Roboto font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_image .cstm_textup").addClass("font-Roboto");

      $(".back_image .cstm_textup").removeClass(
        "font-Socialist font-Roboto font-Manderley font-Crosterian font-Whiphand"
      );
      $(".back_image .cstm_textup").addClass("font-Roboto");

      $("#design-text").removeClass(
        "font-Socialist font-Roboto font-Manderley font-Crosterian font-Whiphand"
      );
      $("#design-text").addClass("font-Roboto");
      $(".conva_imgs").css("display", "none");

      /* checkselectcolortextureimga*/
      var selected_colonam = $(".inner_varinat .color_items.active").attr(
        "data-color"
      );
      var base64 = $("#colo64_" + selected_colonam).attr("src");
      console.log(base64);
      $(".cstm_textup").css("background-image", 'url("' + base64 + '")');
      $(".back_tab").removeAttr("disabled");
      $(".front_image").removeClass("active");
    } else {
       $('.outerinner_logo_designs_content').removeClass("active");
              $('.back_outer').removeClass("hide");
      $(".inner_logo_designs_content").removeClass("active");
      $(".animal").addClass("hide");
      $(".line").addClass("hide");
      $(".sports").addClass("hide");
       $(".travel").addClass("hide");
      $(".nature").addClass("hide");
      $(".weekend").addClass("hide");
      $(".back_sports").addClass("hide");
      $(".back_image").removeClass("active");

      $("#inverseCheckbox").prop("checked", false);
      $("#backinverseCheckbox").prop("checked", false);

      $("#inverseCheckbox").attr("disabled", "disabled");
      $("#backinverseCheckbox").attr("disabled", "disabled");
      $(".inverse_color").css("display", "none");
      $(".s1").css("display", "none");
      $(".s1").css("display", "none");
      $("#inverseCheckbox").css("display", "none");
      $("#backinverseCheckbox").css("display", "none");

      $(".left_image_customize").removeClass("both_textactive");

      var leftbox = $(".popup_box .eleft_image_customize").html();
      var rghtbox = $(".popup_box .eright_section_cutomise").html();
      // $('.outer_box_customizer').addClass('active');
      $("body").addClass("customizer_active");
      $(".popup_pd_customizer").addClass("active");
      // $(".left_image_customize").html(leftbox);
      $(".upprrig").html(rghtbox);
      var checkval = $(".js-color-swatch:checked").val();
      var colo = checkval
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
      console.log(colo);
      $("." + colo).trigger("click");

      var variant_iid = $(".sw_" + colo).attr("data-varinatid");
      console.log(variant_iid);
      $(".variant_id").attr("data-variant", variant_iid);
      $(".uploadingimg").removeAttr("src");
      $(".logo_img_gal").attr("src", "");
      $(".text_uploaded .cstm_textup").html("");
      $(".addtocart_box").addClass("hide");
      $(".edit_front_tab").addClass("hide");
      $(".edit_back_tab").addClass("hide");
      $(".edit_front_tab").removeClass("active");
      $(".edit_back_tab").removeClass("active");
      $(".front_tab").removeClass("hide");
      $(".front_tab").addClass("active");
      $(".back_tab").removeClass("active");
      $(".back_tab").removeClass("hide");
      $(".text_ctent").html("");
      $("#design-text").val("");
      $(".inner_text_design_content").removeClass("active");
      $(".left_image_customize").removeClass("both_active");

      $(".font_sstyle_front").html("");
      $(".font_sstyle_back").html("");
      $(".front_image_url").html("");
      $(".back_image_url").html("");
      $(".front_uploaded_content").html("");
      $(".back_uploaded_content").html("");
      $(".downloadhtml").removeAttr("href");
      $(".downloadhtml").removeAttr("download");
      $(".font_items").removeClass("active");
      $(".font_items.font-Roboto").addClass("active");
      $("#customize_chk-label").removeClass("active");
      $(".block-right").removeClass("active");
      $("#customize_chk-label").addClass("none");
      $(".block-right").attr("disabled", "disabled");

      $(".front_image .cstm_textup").removeClass(
        "font-Socialist font-Roboto font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_image .cstm_textup").addClass("font-Roboto");
      $("#design-text").removeClass(
        "font-Socialist font-Roboto font-Manderley font-Crosterian font-Whiphand"
      );
      $("#design-text").addClass("font-Roboto");
      $(".conva_imgs").css("display", "none");

      /* checkselectcolortextureimga*/
      var selected_colonam = $(".inner_varinat .color_items.active").attr(
        "data-color"
      );
      var base64 = $("#colo64_" + selected_colonam).attr("src");
      console.log(base64);
      $(".cstm_textup").css("background-image", 'url("' + base64 + '")');
      $(".back_tab").removeAttr("disabled");
    }
  });

  /*
   * variant on changes
   */
  $(document).on("click", ".customizer_variant .color_items", function () {
    $(".customizer_variant .color_items").removeClass("active");
    $(this).addClass("active");
    $(".coolor_name").removeClass("active");
    var selectedVar = $("span.color_items.active");
    selectedVar
      .parents(".customizer_variant")
      .find(".coolor_name")
      .addClass("active");

    if ($(".color_items.product_soldout.active")[0]) {
      $(".custom_addtocart").attr("disabled", "disabled");
      $(".custom_addtocart").html("Sold Out");
    } else {
      $(".custom_addtocart").removeAttr("disabled");
      $(".custom_addtocart").html("ADD TO CART");
    }

    var currentclor = $(this).attr("data-color");
    var current_id = $(".sw_" + currentclor).attr("data-varinatid");
    console.log("ss" + current_id);
    $(".product_details .variant_id").attr("data-variant", current_id);
    var currentFrontImage = $(".sw_" + currentclor).attr("data-front");
    var CurrentBackImage = $(".sw_" + currentclor).attr("data-back");
    // $(this).attr('data-varinat',current_id);
    console.log(currentFrontImage);
    $(".main_front_image").attr("src", currentFrontImage);
    $(".main_back_image").attr("src", CurrentBackImage);

    /* checkselectcolortextureimga*/
    var selected_colonam1 = $(".inner_varinat .color_items.active").attr(
      "data-color"
    );
    var base641 = $("#colo64_" + selected_colonam1).attr("src");
    console.log(base641);
    $(".cstm_textup").css("background-image", 'url("' + base641 + '")');
  });

  /*
   * close customize
   */
  $(document).on("click", ".close_customize", function () {
    
    $(".popup_pd_customizer").removeClass("active");
    $(".review_design_uploadimg").removeClass("active");
    $(".input-options").removeClass("hide");
    $("body").removeClass("customizer_active");
    $(".cancle_btn").addClass("hide");
    $(".accept_btn").addClass("hide");
    $(".clear_btn").removeClass("hide");
    $(".preview_btn").removeClass("hide");

    $(".fileinput").val("");
    $("#preview_img").removeAttr("src");
    $("#cropped_image").removeAttr("src");
    $(".uploadingimg").removeAttr("src");
    $(".text_uploaded .cstm_textup").html("");

    $(".design_uplod").removeClass("active");
    $(".selected_design_box").removeClass("active");
    $(".inner_logo_designs_content").removeClass("active");
    $(".inner_text_design_content").removeClass("active");
    $(".customize-selection").removeClass("hide");

    $(".front_text_preview").addClass("hide");
    $(".back_text_preview").addClass("hide");
    $(".front_text_preview").removeClass("active");
    $(".back_text_preview").removeClass("active");
    $(".front_image").removeClass("hide");
    $(".front_image").addClass("active");

    $(".selected_design_box").removeClass("active");
    $(".inner_logo_designs_content").removeClass("active");
    $(".inner_text_design_content").removeClass("active");
    $(".button_tabs .tab_items").removeClass("active");
    $(".front_tab").addClass("active");
    $(".back_tab").attr("disabled", "disabled");
    $(".edit_front_tab ").addClass("hide");
    $(".edit_back_tab ").addClass("hide");
  });

  /*
   * buttons tab
   */
  $(document).on("click", ".button_tabs .tab_items", function () {
    $("#design-text").val("");
    $(".tab_items").removeClass("active");
    $(this).addClass("active");
    setTimeout(function () {
      if ($(".front_tab.tab_items.active")[0]) {
        // if text active
        if ($(".inner_text_design_content.active")[0]) {
          $("#design-text").val("");
          $(".front_text_preview").addClass("active");
          $(".front_text_preview").removeClass("hide");
          $(".back_text_preview").removeClass("active");
          $(".back_text_preview").addClass("hide");
          $(".front_image").removeClass("active");
          $(".back_image").removeClass("active");
          var front_textvl = $(".front_image .cstm_textup").html();
          $("#design-text").val("");
        } else if ($(".selected_design_box.active")[0]) {
          $(".uploadingimg .resizable").removeClass("hide");
          $(".front_image").addClass("active");
          $(".back_image").removeClass("active");
          $("#inverseCheckbox").css("display", "inline");
          $(".s1").css("display", "inline");
          $("#backinverseCheckbox").css("display", "none");
          $(".s2").css("display", "none");
        } else {
          $(".front_image").addClass("active");
          $(".back_image").removeClass("active");
        }
      }
      if ($(".back_tab.tab_items.active")[0]) {
        // if text active
        if ($(".inner_text_design_content.active")[0]) {
          $(".back_tab").removeAttr("disabled");
          $(".back_text_preview").addClass("active");
          $(".back_text_preview").removeClass("hide");
          $(".front_text_preview").removeClass("active");
          $(".front_text_preview").addClass("hide");
          $(".front_image").removeClass("active");
          $(".back_image").removeClass("active");
          var front_textv2 = $(".back_image .cstm_textup").html();
          $("#design-text").val("");
        } else if ($(".selected_design_box.active")[0]) {
          $(".uploadingimg .resizable").removeClass("hide");
          $(".back_image").addClass("active");
          $(".front_image").removeClass("active");
          $("#inverseCheckbox").css("display", "none");
          $(".s1").css("display", "none");
          $("#backinverseCheckbox").css("display", "inline");
          $(".s2").css("display", "inline");
        } else {
          $(".front_image").removeClass("active");
          $(".back_image").addClass("active");
        }
      }
    }, 1000);
  });

  /* logo section*/

  $(document).on("click", ".logo_design", function () {
    $(".customize-selection").addClass("hide");
    $('.family').addClass('hide');
    $('.back_family').addClass('hide');
    $(".selected_design_box").removeClass("active");
    $(".inner_selected_design.design_uplod.customization-section").removeClass(
      "active"
    );
    $(".inner_logo_designs_content").addClass("active");

    $(".inner_logo_designs_content .back_logo").removeAttr("style");
    $(".inner_logo_designs_content .logos_content").removeAttr("style");
    $(".inner_logo_designs_content .logo_gallery").removeAttr("style");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".front_tab").removeClass("hide");
    $(".back_tab").removeClass("hide");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").addClass("hide");
    $(".color_customize_variants").removeAttr("style");
    $(".inner_gallerry_wraper.animal_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.sports_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.line_gallery").removeClass("hide");
     $(".inner_gallerry_wraper.nature_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.weekend_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.travel_gallery").removeClass("hide");
    $(".inner_gallerry_wraper.family_gallery").removeClass("hide");
    
  });

  /* logo details on click*/
  $(document).on("click", ".logo-item-detail img", function () {
    $(".logo-item-detail .image").removeClass("active");
    $(this).parent(".image").addClass("active");
    $(".gallery_nav_design .preview_btn").removeAttr("disabled");
    $(".gallery_nav_design .clear_btn").removeAttr("disabled");
if ($(this).parents('.outerinner_logo_designs_content').hasClass('active')) {
 
     $(".outergallery_nav_design .preview_btn").removeAttr("disabled");
    $(".outergallery_nav_design .clear_btn").removeAttr("disabled");
}
    var csrc = $(this).parent(".image").attr("data-texture");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").addClass("hide");
    $(".front_tab").removeClass("hide");
    $(".back_tab").removeClass("hide");
    var logoName = $(this).parents('.logo-item-detail').find('.prepared-item-title').html();
    console.log(logoName);
    /* front src*/
    if ($(".front_tab.tab_items.active")[0]) {
      $('.gallery_name_front').html(logoName);
      $("#imageCanvas").removeAttr("width");
      $("#imageCanvas").removeAttr("height");
      $("#inverseCheckbox").attr("disabled", "disabled");
      $("#uploaded-image").removeAttr("src");
      $(".front_image_url").html(csrc);
      // $(".font_sstyle_front").html("");
      $(".front_image .resizable").addClass("hide");
      // $(".front_image .text_uploaded").addClass("hide");
      $(".front_image .resizable").removeClass("active");
      // $(".front_image .text_uploaded").removeClass("active");
      $(".front_image .logo_img img.logo_img_gal").attr("src", csrc);
      $(".front_image_invert").html("No");
      $(".front_image .logo_img").removeClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .logo_img_gal").removeClass("hide");

      var fronthtml1 = $(".front_image .cstm_textup").html();
      if (fronthtml1 != "") {
        $(".front_image .text_uploaded").removeClass("hide");
        $(".front_image .text_uploaded").addClass("active");
        $(".front_image").addClass("both_textactive");
      } else {
        $(".front_image").removeClass("both_textactive");
      }
    }
    // back tabs
    if ($(".back_tab.tab_items.active")[0]) {
        $('.gallery_name_back').html(logoName);
      $("#imageCanvasback").removeAttr("width");
      $("#imageCanvasback").removeAttr("height");
      $("#buploaded-image").removeAttr("src");
      $("#backinverseCheckbox").attr("disabled", "disabled");
      $(".back_image_url").html(csrc);
      // $(".font_sstyle_back").html("");
      $(".back_image .resizable").addClass("hide");
      $(".back_image .resizable").removeClass("active");
      // $(".back_image .text_uploaded").addClass("hide");
      $(".back_image .logo_img img.logo_img_gal").attr("src", csrc);
      $(".back_image_invert").html("No");
      $(".back_image .logo_img").removeClass("hide");
      $(".back_image .logo_img_gal").removeClass("hide");

      var backhtml1 = $(".back_image .cstm_textup").html();
      if (backhtml1 != "") {
        $(".back_image .text_uploaded").removeClass("hide");
        $(".back_image .text_uploaded").addClass("active");
        $(".back_image").addClass("both_textactive");
      } else {
        $(".back_image").removeClass("both_textactive");
      }
    }
  });

  $(document).on("click", ".back_logo", function () {
    $(".inner_logo_designs_content").removeClass("active");
    $(".customize-selection").removeClass("hide");
    $(".animal").addClass("hide");
    $(".sports").addClass("hide");
    $(".line").addClass("hide");
    $(".family").addClass("hide");
    $(".addtocart_box").addClass("hide");
  });

  /*
   * text upload section
   */
  $(document).on("click", ".text_upload", function () {
    $(".text_nav_design .clear_btn").removeClass("hide");
    $(".text_nav_design .preview_btn ").removeClass("hide");
    $(".customize-selection").addClass("hide");
    $(".back_text").removeAttr("style");
    $(".text_font_section").removeAttr("style");
    $(".design-text").val("");
    $(".selected_design_box").removeClass("active");
    $(".inner_selected_design.design_uplod.customization-section").removeClass(
      "active"
    );
    $(".inner_logo_designs_content").removeClass("active");
    $(".inner_text_design_content").addClass("active");
    $(".front_image").removeClass("active");
    $(".back_image").removeClass("active");
    $(".edit_front_tab").addClass("hide");
    $(".edit_back_tab").addClass("hide");
    $(".front_tab").addClass("hide");
    $(".front_tab").removeClass("hide");
    $(".back_tab").removeClass("hide");

    if ($(".back_tab.tab_items.active")[0]) {
      $(".front_text_preview").removeClass("active");
      $(".front_text_preview").addClass("hide");
      $(".back_text_preview").removeClass("hide");
      $(".back_text_preview").addClass("active");
      $(".text_ctent").hide();
    }
    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview").removeClass("hide");
      $(".front_text_preview").addClass("active");
      $(".back_text_preview").removeClass("active");
      $(".back_text_preview").addClass("hide");
      $(".text_ctent").hide();
    }

    var checktabs = setInterval(function () {
      if ($(".front_text_preview.active")[0]) {
        var frontd = $(".font_items.active").attr("data-font");
        // $('.text_ctent').addClass('font-'+frontd);
        $(".front_image .cstm_textup").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".front_text_preview .text_ctent").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".front_image .cstm_textup").addClass("font-" + frontd);
        $(".front_text_preview .text_ctent").addClass("font-" + frontd);
        var chkfttf = $(".front_uploaded_content").html();
        if (chkfttf != "") {
          $(".font_sstyle_front").html(frontd);
        } else {
          $(".font_sstyle_front").html("");
        }

        clearInterval(checktabs);
      }
      if ($(".back_text_preview.active")[0]) {
        var frontds = $(".font_items.active").attr("data-font");
        $(".back_image .cstm_textup").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".back_text_preview .text_ctent").removeClass(
          "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
        );
        $(".back_image .cstm_textup").addClass("font-" + frontds);
        $(".back_text_preview .text_ctent").addClass("font-" + frontds);

        var chkfttf = $(".back_uploaded_content").html();
        if (chkfttf != "") {
          $(".font_sstyle_back").text(frontds);
        } else {
          $(".font_sstyle_back").text("");
        }

        clearInterval(checktabs);
      }
    }, 100);
  });

  $(document).on("click", ".back_text", function () {
    $("#design-text").val("");
    $(".inner_text_design_content").removeClass("active");
    $(".inner_text_design_content").removeAttr("style");
    $(".back_text").removeAttr("style");
    $(".text_font_section").removeAttr("style");
    $(".customize-selection").removeClass("hide");

    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview").addClass("hide");
      $(".front_text_preview").removeClass("active");
      $(".back_text_preview").removeClass("active");
      $(".back_text_preview").addClass("hide");
      $(".front_image").addClass("active");
      $(".back_image").removeClass("active");
      $(".front_image .text_uploaded").addClass("active");
      $(".front_image .text_uploaded").removeClass("hide");
      $(".front_image .logo_img").addClass("hide");
      $(".front_image .resizable").addClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .resizable").removeClass("active");
    }
    if ($(".back_tab.tab_items.active")[0]) {
      $(".front_text_preview").addClass("hide");
      $(".front_text_preview").removeClass("active");
      $(".back_text_preview").removeClass("active");
      $(".back_text_preview").addClass("hide");
      $(".back_image").addClass("active");
      $(".front_image").removeClass("active");
      $(".back_image .text_uploaded").addClass("active");
      $(".back_image .text_uploaded").removeClass("hide");
      $(".front_image .logo_img").addClass("hide");
      $(".front_image .resizable").addClass("hide");
      $(".front_image .logo_img").removeClass("active");
      $(".front_image .resizable").removeClass("active");
    }
  });


   var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
// Allow only alphabets, numbers, and space
var RE_SPECIAL = /[^a-zA-Z0-9\s]/g;

$(document).on("keyup keydown change paste input", "#design-text", function (event) {
  if (event.key === "Enter") {
    event.preventDefault();
    return false;
  }

  var $elem = $(this);
  var content = $elem.val();

  // Remove emojis and special characters
  if (RE_EMOJI.test(content) || RE_SPECIAL.test(content)) {
    content = content.replace(RE_EMOJI, '').replace(RE_SPECIAL, '');
    $elem.val(content);
  }

  var dInput = content;
  var valLength = dInput.length;
  var dsize = parseInt($elem.attr("data-size")) || 50;

  if (valLength > dsize) {
    $(".alert.slide-down").removeClass("hide");
    $(".text_nav_design .preview_btn").attr("disabled", "disabled");
  } else {
    $(".alert.slide-down").addClass("hide");
    $(".text_nav_design .preview_btn").removeAttr("disabled");

    if ($(".front_tab.tab_items.active")[0]) {
      $(".front_text_preview .text_ctent").removeAttr("style");
      $(".front_text_preview").removeClass("hide").addClass("active");
      $(".back_text_preview").removeClass("active").addClass("hide");

      $(".front_text_preview .text_ctent, .front_image .cstm_textup, .front_uploaded_content").text(dInput);
      $(".nav_design_buttons.text_nav_design .preview_btn, .nav_design_buttons.text_nav_design .clear_btn").removeAttr("disabled");
      $(".front_image .logo_img").addClass("hide").removeClass("active");

      var frontfondata = $(".font_items.active").attr("data-font");
      $(".font_sstyle_front").text(frontfondata);
      $(".front_image").attr("data-size", valLength);
    }

    if ($(".back_tab.tab_items.active")[0]) {
      $(".back_text_preview .text_ctent").removeAttr("style");
      $(".front_text_preview").removeClass("active").addClass("hide");
      $(".back_text_preview").removeClass("hide").addClass("active");

      $(".back_text_preview .text_ctent, .back_image .cstm_textup, .back_uploaded_content").text(dInput);
      $(".nav_design_buttons.text_nav_design .preview_btn, .nav_design_buttons.text_nav_design .clear_btn").removeAttr("disabled");
      $(".back_image .logo_img").addClass("hide").removeClass("active");

      var backfondata = $(".font_items.active").attr("data-font");
      $(".font_sstyle_back").text(backfondata);
      $(".back_image").attr("data-size", valLength);
    }
  }
});

//  var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
// var cmdDown = false;
//   $(document).on(
//     "keyup keydown change paste input",
//     "#design-text",
//     function (event) {
//       if (event.key == "Enter") {
//         event.preventDefault();
//         return false;
//       } else {
//     var $elem = $(this);
//     var content = $elem.val();
//          if (RE_EMOJI.test(content)) {
          
//       $elem.val(content.replace(RE_EMOJI, ''));
//   var dInput = $(this).val();
//         var valLength = dInput.length;
//         var dsize = $(this).attr("data-size");
//         if (valLength > dsize) {
//           $(".alert.slide-down").removeClass("hide");
//           $(".text_nav_design .preview_btn").attr("disabled", "disabled");
//         } else {
//           $(".alert.slide-down").addClass("hide");
//           $(".text_nav_design .preview_btn").removeAttr("disabled");
//           if ($(".front_tab.tab_items.active")[0]) {
//             $(".front_text_preview .text_ctent").removeAttr("style");
//             $(".front_text_preview").removeClass("hide");
//             $(".front_text_preview").addClass("active");
//             $(".back_text_preview").removeClass("active");
//             $(".back_text_preview").addClass("hide");
//             $(".front_text_preview .text_ctent").text(dInput);
//             $(".front_image .cstm_textup").text(dInput);
//             $(".front_uploaded_content").text(dInput);
//             $(".nav_design_buttons.text_nav_design .preview_btn").removeAttr(
//               "disabled"
//             );
//             $(".nav_design_buttons.text_nav_design .clear_btn").removeAttr(
//               "disabled"
//             );
//             $(".front_image .logo_img").addClass("hide");
//             $(".front_image .logo_img").removeClass("active");
//             // $(".front_image .logo_img_gal").attr("src", "");
//             var frontfondata = $(".font_items.active").attr("data-font");
//             $(".font_sstyle_front").text(frontfondata);
//             $(".front_image").attr("data-size", valLength);
//           }
//           if ($(".back_tab.tab_items.active")[0]) {
//             $(".back_text_preview .text_ctent").removeAttr("style");
//             $(".front_text_preview").removeClass("active");
//             $(".front_text_preview").addClass("hide");
//             $(".back_text_preview").removeClass("hide");
//             $(".back_text_preview").addClass("active");
//             $(".back_text_preview .text_ctent").text(dInput);
//             $(".back_image .cstm_textup").text(dInput);
//             $(".back_uploaded_content").text(dInput);
//             $(".nav_design_buttons.text_nav_design .preview_btn").removeAttr(
//               "disabled"
//             );
//             $(".nav_design_buttons.text_nav_design .clear_btn").removeAttr(
//               "disabled"
//             );
//             $(".back_image .logo_img").addClass("hide");
//             $(".back_image .logo_img").removeClass("active");
//             // $(".back_image .logo_img_gal").attr("src", "");
//             var backfondata = $(".font_items.active").attr("data-font");
//             $(".font_sstyle_back").text(backfondata);
//             $(".back_image").attr("data-size", valLength);
//           }
//         }
//     }else{

//         var dInput = $(this).val();
//         var valLength = dInput.length;
//         var dsize = $(this).attr("data-size");
//         if (valLength > dsize) {
//           $(".alert.slide-down").removeClass("hide");
//           $(".text_nav_design .preview_btn").attr("disabled", "disabled");
//         } else {
//           $(".alert.slide-down").addClass("hide");
//           $(".text_nav_design .preview_btn").removeAttr("disabled");
//           if ($(".front_tab.tab_items.active")[0]) {
//             $(".front_text_preview .text_ctent").removeAttr("style");
//             $(".front_text_preview").removeClass("hide");
//             $(".front_text_preview").addClass("active");
//             $(".back_text_preview").removeClass("active");
//             $(".back_text_preview").addClass("hide");
//             $(".front_text_preview .text_ctent").text(dInput);
//             $(".front_image .cstm_textup").text(dInput);
//             $(".front_uploaded_content").text(dInput);
//             $(".nav_design_buttons.text_nav_design .preview_btn").removeAttr(
//               "disabled"
//             );
//             $(".nav_design_buttons.text_nav_design .clear_btn").removeAttr(
//               "disabled"
//             );
//             $(".front_image .logo_img").addClass("hide");
//             $(".front_image .logo_img").removeClass("active");
//             // $(".front_image .logo_img_gal").attr("src", "");
//             var frontfondata = $(".font_items.active").attr("data-font");
//             $(".font_sstyle_front").text(frontfondata);
//             $(".front_image").attr("data-size", valLength);
//           }
//           if ($(".back_tab.tab_items.active")[0]) {
//             $(".back_text_preview .text_ctent").removeAttr("style");
//             $(".front_text_preview").removeClass("active");
//             $(".front_text_preview").addClass("hide");
//             $(".back_text_preview").removeClass("hide");
//             $(".back_text_preview").addClass("active");
//             $(".back_text_preview .text_ctent").text(dInput);
//             $(".back_image .cstm_textup").text(dInput);
//             $(".back_uploaded_content").text(dInput);
//             $(".nav_design_buttons.text_nav_design .preview_btn").removeAttr(
//               "disabled"
//             );
//             $(".nav_design_buttons.text_nav_design .clear_btn").removeAttr(
//               "disabled"
//             );
//             $(".back_image .logo_img").addClass("hide");
//             $(".back_image .logo_img").removeClass("active");
//             // $(".back_image .logo_img_gal").attr("src", "");
//             var backfondata = $(".font_items.active").attr("data-font");
//             $(".font_sstyle_back").text(backfondata);
//             $(".back_image").attr("data-size", valLength);
//           }
//         }

//          }
        
//       }
//     }
//   );

  /* start keyup */
  //   $(document).on("keyup change paste input", "#design-text", function (e) {
  // if (e.keyCode == 13) {
  //         e.preventDefault();
  //     }
  //     var dInput = $(this).val();

  //     console.log(dInput);
  //     var valLength = dInput.length;
  //    var dsize = $(this).attr('data-size');
  //     if (valLength > dsize) {
  //       $(".alert.slide-down").removeClass("hide");
  //       $(".text_nav_design .preview_btn").attr("disabled", "disabled");
  //     } else {
  //       $(".alert.slide-down").addClass("hide");
  //       $(".text_nav_design .preview_btn").removeAttr("disabled");
  //       if ($(".front_tab.tab_items.active")[0]) {
  //         $(".front_text_preview .text_ctent").removeAttr("style");
  //         $(".front_text_preview").removeClass("hide");
  //         $(".front_text_preview").addClass("active");
  //         $(".back_text_preview").removeClass("active");
  //         $(".back_text_preview").addClass("hide");
  //         $(".front_text_preview .text_ctent").text(dInput);
  //         $(".front_image .cstm_textup").text(dInput);
  //         $(".front_uploaded_content").text(dInput);
  //         $(".nav_design_buttons.text_nav_design .preview_btn").removeAttr(
  //           "disabled"
  //         );
  //         $(".nav_design_buttons.text_nav_design .clear_btn").removeAttr(
  //           "disabled"
  //         );
  //         $(".front_image .logo_img").addClass("hide");
  //         $(".front_image .logo_img").removeClass("active");
  //         // $(".front_image .logo_img_gal").attr("src", "");
  //         var frontfondata = $(".font_items.active").attr("data-font");
  //         $(".font_sstyle_front").text(frontfondata);
  //         $('.front_image').attr('data-size',valLength);
  //       }
  //       if ($(".back_tab.tab_items.active")[0]) {
  //         $(".back_text_preview .text_ctent").removeAttr("style");
  //         $(".front_text_preview").removeClass("active");
  //         $(".front_text_preview").addClass("hide");
  //         $(".back_text_preview").removeClass("hide");
  //         $(".back_text_preview").addClass("active");
  //         $(".back_text_preview .text_ctent").text(dInput);
  //         $(".back_image .cstm_textup").text(dInput);
  //         $(".back_uploaded_content").text(dInput);
  //         $(".nav_design_buttons.text_nav_design .preview_btn").removeAttr(
  //           "disabled"
  //         );
  //         $(".nav_design_buttons.text_nav_design .clear_btn").removeAttr(
  //           "disabled"
  //         );
  //         $(".back_image .logo_img").addClass("hide");
  //         $(".back_image .logo_img").removeClass("active");
  //         // $(".back_image .logo_img_gal").attr("src", "");
  //         var backfondata = $(".font_items.active").attr("data-font");
  //         $(".font_sstyle_back").text(backfondata);
  //         $('.back_image').attr('data-size',valLength);
  //       }
  //     }

  //   });
  /* close keyup */

  $(document).on("click", ".font_items", function () {
    $(".font_items").removeClass("active");
    $(this).addClass("active");
    var currentfont = $(this).attr("data-font");

    /* front font*/
    if ($(".front_tab.tab_items.active")[0]) {
      $(".font_sstyle_front").text(currentfont);
      $("#design-text").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".front_image").addClass("cstm_font_" + currentfont);
      $("#design-text").addClass("font-" + currentfont);

      $(".front_text_preview .text_ctent").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_text_preview .text_ctent").addClass("font-" + currentfont);
      $(".front_image .cstm_textup").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".front_image .cstm_textup").addClass("font-" + currentfont);
    }

    /* back font style*/
    if ($(".back_tab.tab_items.active")[0]) {
      $(".font_sstyle_back").text(currentfont);
      $("#design-text").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $("#design-text").addClass("font-" + currentfont);

      $(".back_image").removeClass(
        "cstm_font_Roboto cstm_font_Socialist cstm_font_Manderley cstm_font-Crosterian cstm_font_Whiphand"
      );
      $(".back_image").addClass("cstm_font_" + currentfont);
      $(".back_text_preview .text_ctent").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".back_text_preview .text_ctent").addClass("font-" + currentfont);
      $(".back_image .cstm_textup").removeClass(
        "font-Roboto font-Socialist font-Manderley font-Crosterian font-Whiphand"
      );
      $(".back_image .cstm_textup").addClass("font-" + currentfont);
    }
  });

  $(document).on("click", ".add", function () {
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
  });

  $(document).on("click", ".sub", function () {
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1)
        $(this)
          .next()
          .val(+$(this).next().val() - 1);
    }
  });

  $(document).on("click", ".custom_addtocart", function () {
    $(".cstmizer_addtocart_popup").addClass("active");
    var ftexthtml = $(".front_image .cstm_textup").html();
    var btexthtml = $(".back_image .cstm_textup").html();
    /* logo */
  });

  $(document).on("click", ".close_adtc", function () {
    $(".cstmizer_addtocart_popup").removeClass("active");
  });

  $(document).on("click", ".block_close", function () {
    $(".cstmizer_addtocart_popup").removeClass("active");
  });

  $(document).on("click", "button.block-right.agree.active", function (e) {
    e.preventDefault();
    var swatchname = $(".coolor_name.active").html();
    console.log("swatchname" + swatchname);
    var gallery_name_front = $('.gallery_name_front').html();
    var gallery_name_back = $('.gallery_name_back').html();
    var product_title = $(".left_image_customize").attr("data-title");
    var pricemoney = $(".left_image_customize").attr("data-moncurreny");
    var pricewithoutcurrency = $(".left_image_customize").attr("data-price");
    var currencyf = $(".left_image_customize").attr("data-cur");
    var qty = $(".qty_custom").val();
    var priceplus1 = 0;
    var priceplus2 = 0;
    var priceplus3 = 0;
    var priceplus4 = 0;

    var eachprice1 = "";
    var eachprice2 = "";
    var eachprice3 = "";
    var eachprice4 = "";

    var qtycustomized1 = 0;
    var qtycustomized2 = 0;
    var qtycustomized3 = 0;
    var qtycustomized4 = 0;
    var customized_pd = parseInt($(".customized_product").attr("data-id"));
    var var_id = parseInt($(".variant_id").attr("data-variant"));
    var customized_img = $(".customized_product").attr("data-img");
    var frntttxt = "";
    var backtexxt = "";
var frontcheck = false;
var backcheck = false;
    var fronttext = $(".front_uploaded_content").html();
    if (fronttext != "") {
      qtycustomized1 = 1;
      priceplus1 = pricewithoutcurrency;
      eachprice1 = pricemoney;
      frntttxt = fronttext;
      frontcheck = true;
    }
    var backtext = $(".back_uploaded_content").html();
    if (backtext != "") {
      qtycustomized2 = 1;

      priceplus2 = pricewithoutcurrency;

      eachprice2 = pricemoney;
      backtexxt = backtext;
      backcheck = true;
    }

    var frontinvert = "";
    var backinvert = "";

    var front_image_invert = $(".front_image_invert").html();
    if (front_image_invert != "") {
      frontinvert = front_image_invert;
    }

    var back_image_invert = $(".back_image_invert").html();
    if (back_image_invert != "") {
      backinvert = back_image_invert;
    }

    fronturlimage = "";
    backurlimage = "";

    var fronturl = $(".front_image_url").html();
    if (fronturl != "") {
      fronturlimage = fronturl;
      qtycustomized3 = 1;
      priceplus3 = pricewithoutcurrency;
      eachprice3 = pricemoney;
       frontcheck = true;
    }
    var backurl = $(".back_image_url").html();
    if (backurl != "") {
      backurlimage = backurl;
      qtycustomized4 = 1;
      priceplus4 = pricewithoutcurrency;
      eachprice4 = pricemoney;
       backcheck = true;
    }
    console.log(
      priceplus1 + "-" + priceplus2 + "-" + "-" + priceplus3 + "-" + priceplus4
    );
    var totalamount =
      parseFloat(priceplus1) +
      parseFloat(priceplus2) +
      parseFloat(priceplus3) +
      parseFloat(priceplus4);
    var customQty =
      parseInt(qtycustomized1) +
      parseInt(qtycustomized2) +
      parseInt(qtycustomized3) +
      parseInt(qtycustomized4);
    console.log("customQty" + customQty);

    var frontfont = "";
    var font_sstyle_front = $(".font_sstyle_front").html();
    if (font_sstyle_front != "") {
      frontfont = font_sstyle_front;
    }
    var backfont = "";
    var font_sstyle_back = $(".font_sstyle_back").html();
    if (font_sstyle_back != "") {
      backfont = font_sstyle_back;
    }
    var items = [];
    items.push({
      id: var_id,
      quantity: qty,
        properties: {
          _customised_product:"yes",
        },
    });

    // items.push({
    //   id: customized_pd,
    //   quantity: customQty,
    //   properties: {
    //     _customised_product:"yes",
    //     _main_product: product_title + "-" + swatchname,
    //     Front_image: fronturlimage,
    //     Front_image_price: eachprice3,
    //     Front_name: frntttxt,
    //     Front_gallery_image_name: gallery_name_front,
    //     _Front_name_font: frontfont,
    //     _Front_image_invert: frontinvert,
    //     Back_image: backurlimage,
    //     Back_image_price: eachprice4,
    //     Back_name: backtexxt,
    //     Back_gallery_image_name:gallery_name_back,
    //     _Back_name_font: backfont,
    //     _Back_image_invert: backinvert,
    //     Total: currencyf + "" + totalamount.toFixed(2),
    //   },
    // });
/** front customisation */
if(frontcheck == true && backcheck == false){
  items.push({
  id: customized_pd,
  quantity: customQty,
  properties: {
    "_Customised Product": "yes",
    "FRONT ENGRAVING": product_title + "-" + swatchname,
    "FRONT NAME": frntttxt,
    "FRONT FONT": frontfont,
    "FRONT IMAGE": fronturlimage,
    "FRONT IMAGE PRICE": eachprice3,
    "FRONT GALLERY IMAGE NAME": gallery_name_front,
    "_FRONT IMAGE INVERT": frontinvert,
    // "Total": currencyf + "" + totalamount.toFixed(2),
  },
});
}
/** if back customisation */
if(frontcheck == false && backcheck == true){
  items.push({
  id: customized_pd,
  quantity: customQty,
  properties: {
    "_Customised Product": "yes",
    "BACK ENGRAVING": product_title + "-" + swatchname,
    "BACK NAME": backtexxt,
    "BACK FONT": backfont,
    "BACK IMAGE": backurlimage,
    "BACK IMAGE PRICE": eachprice4,
    "BACK GALLERY IMAGE NAME": gallery_name_back,
    "_BACK IMAGE INVERT": backinvert,
    // "Total": currencyf + "" + totalamount.toFixed(2),
  },
});
}
/** if all check true */
if(frontcheck == true && backcheck == true){
  items.push({
  id: customized_pd,
  quantity: customQty,
  properties: {
    "_Customised Product": "yes",
    "FRONT ENGRAVING": product_title + "-" + swatchname,
    "FRONT NAME": frntttxt,
    "FRONT FONT": frontfont,
    "FRONT IMAGE": fronturlimage,
    "FRONT IMAGE PRICE": eachprice3,
    "FRONT GALLERY IMAGE NAME": gallery_name_front,
    "_Front Image Invert": frontinvert,
  "BACK ENGRAVING": product_title + "-" + swatchname,
    "BACK NAME": backtexxt,
    "BACK FONT": backfont,
    "BACK IMAGE": backurlimage,
    "BACK IMAGE PRICE": eachprice4,
    "BACK GALLERY IMAGE NAME": gallery_name_back,
    "_Back Image Invert": backinvert,
    // "Total": currencyf + "" + totalamount.toFixed(2),
  },
});
}


// items.push({
//   id: customized_pd,
//   quantity: customQty,
//   properties: {
//     "_Customised Product": "yes",
//     "_Main Product": product_title + "-" + swatchname,
//     "Front Image": fronturlimage,
//     "Front Image Price": eachprice3,
//     "Front Name": frntttxt,
//     "Front Gallery Image Name": gallery_name_front,
//     "_Front Name Font": frontfont,
//     "_Front Image Invert": frontinvert,
//     "Back Image": backurlimage,
//     "Back Image Price": eachprice4,
//     "Back Name": backtexxt,
//     "Back Gallery Image Name": gallery_name_back,
//     "_Back Name Font": backfont,
//     "_Back Image Invert": backinvert,
//     "Total": currencyf + "" + totalamount.toFixed(2),
//   },
// });
    $(".block-right").html("Loading....");
    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: items,
        },
        dataType: "json",
        success: function (response) {
          console.log("Products added to cart successfully1");
          console.log(response);
          $.ajax({
            url: "/cart",
            type: "GET",
            dataType: "html",
            success: function (t) {
              console.log(t);
              $("#CartDrawer").html($(t).find("#CartDrawer").html());
              $(
                ".js-drawer-open-button-right .material-icons-outlined"
              ).trigger("click");
              $(".cstmizer_addtocart_popup ").removeClass("active");
              $(".block-right").html("ACCEPT");
              $(".cstmizer_addtocart_popup").removeClass("active");
              $(".popup_pd_customizer").removeClass("active");
              $(".left_image_customize").removeClass("both_active");
              $(".back_image").removeClass("active");
              $(".logo_img").addClass("hide");
              $(".cstm_textup").html("");
              $(".front_text_preview").addClass("hide");
              $(".back_text_preview").addClass("hide");
              $(".front_text_preview").removeClass("hide");
              $(".back_text_preview").removeClass("hide");
              $(".customize-selection").removeClass("hide");
              $(".selected_design_box").removeClass("active");
              $("inner_logo_designs_content").removeClass("active");
              $("inner_text_design_content ").removeClass("active");
              $('.outerinner_logo_designs_content').removeClass("active");
              $('.back_outer').removeClass("hide");
              $(".design_uplod").removeClass("active");
              $(".front_text_preview").addClass("hide");
              $(".back_text_preview").addClass("hide");
              $(".conva_imgs").css("display", "none");
            },
          });
        },
        error: function (XMLHttpRequest, textStatus) {
          console.error("Error adding products to cart");
        },
      });
    }, 2000);
  });

  /* animal*/
  $(document).on("click", ".inner_gallerry_wraper.animal_gallery", function () {
    $(this).addClass("hide");
    $(".animal").removeClass("hide");
    $(".sports_gallery").addClass("hide");
    $(".line_gallery").addClass("hide");
    $(".pets_gallery").addClass("hide");
    $(".nature_gallery").addClass("hide");
    $(".weekend_gallery").addClass("hide");
    $(".family_gallery").addClass("hide");
    $(".travel_gallery").addClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_animal").removeClass("hide");
    $(".animal .logos_content").css("display", "block");
    $(".animal .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });
  $(document).on("click", ".back_animal.back_inner", function () {
    $(this).addClass("hide");
    $(".animal").addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".pets_gallery").removeClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
     $(".nature_gallery").removeClass("hide");
    $(".weekend_gallery").removeClass("hide");
    $(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_animal").addClass("hide");
  });

  /* sports gallery*/
  $(document).on("click", ".inner_gallerry_wraper.sports_gallery", function () {
    $(this).addClass("hide");
    $(".animal_gallery").addClass("hide");
    $(".line_gallery").addClass("hide");
    $(".nature_gallery").addClass("hide");
    $(".weekend_gallery").removeClass("hide");
    $(".family_gallery").addClass("hide");
    $(".travel_gallery").addClass("hide");
    $(".pets_gallery").addClass("hide");
    $(".sports").removeClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_sports").removeClass("hide");
    $(".sports .logos_content").css("display", "block");
    $(".sports .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });
  $(document).on("click", ".back_sports.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".pets_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
    $(".weekend_gallery").removeClass("hide");
    $(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
    $(".sports").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_sports").addClass("hide");
  });

   /* Line Art gallery*/
  $(document).on("click", ".inner_gallerry_wraper.line_gallery", function () {
    $(this).addClass("hide");
    $(".animal_gallery").addClass("hide");
    $(".sports_gallery").addClass("hide");
    
$(".nature_gallery").addClass("hide");
    $(".weekend_gallery").addClass("hide");
    $(".family_gallery").addClass("hide");
    $(".travel_gallery").addClass("hide");
    $(".pets_gallery").addClass("hide");
    $(".line").removeClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_lineart").removeClass("hide");
    $(".line .logos_content").css("display", "block");
    $(".line .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });
  $(document).on("click", ".back_lineart.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
     $(".weekend_gallery").removeClass("hide");
     $(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
    $(".pets_gallery").removeClass("hide");
    $(".line").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_lineart").addClass("hide");
  });

  /* nature gallery*/
$(document).on("click", ".inner_gallerry_wraper.nature_gallery", function () {
    $(this).addClass("hide");
    $(".animal_gallery").addClass("hide");
   $(".line_gallery").addClass("hide");
    $(".sports_gallery").addClass("hide");
      $(".weekend_gallery").addClass("hide");
      $(".family_gallery").addClass("hide");
    $(".travel_gallery").addClass("hide");
    $(".pets_gallery").addClass("hide");
    $(".nature").removeClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_nature").removeClass("hide");
    $(".nature .logos_content").css("display", "block");
    $(".nature .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });
    $(document).on("click", ".back_nature.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
      $(".weekend_gallery").removeClass("hide");
      $(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
      $(".pets_gallery").removeClass("hide");
    $(".nature").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_nature").addClass("hide");
  });

    /* weekend gallery*/
$(document).on("click", ".inner_gallerry_wraper.weekend_gallery", function () {
    $(this).addClass("hide");
    $(".animal_gallery").addClass("hide");
   $(".line_gallery").addClass("hide");
    $(".sports_gallery").addClass("hide");
    $(".travel_gallery").addClass("hide");
    $(".pets_gallery").addClass("hide");
  $(".nature_gallery").addClass("hide");
  $(".family_gallery").addClass("hide");
    $(".weekend").removeClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_weekend").removeClass("hide");
    $(".weekend .logos_content").css("display", "block");
    $(".weekend .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });
    $(document).on("click", ".back_weekend.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
    $(".weekend_gallery").removeClass("hide");
    $(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
      $(".pets_gallery").removeClass("hide");
    $(".weekend").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_weekend").addClass("hide");
  });
  
  /* travel and adventure gallery*/
  
$(document).on("click", ".inner_gallerry_wraper.travel_gallery", function () {
    $(this).addClass("hide");
    $(".animal_gallery").addClass("hide");
   $(".line_gallery").addClass("hide");
    $(".sports_gallery").addClass("hide");
    $(".nature_gallery").addClass("hide");
      $(".weekend_gallery").addClass("hide");
$(".family_gallery").addClass("hide");
   $(".pets_gallery").addClass("hide");
    
    $(".travel").removeClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_nature_travel").removeClass("hide");
    $(".travel .logos_content").css("display", "block");
    $(".travel .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });

     $(document).on("click", ".back_nature_travel.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
           $(".weekend_gallery").removeClass("hide");
$(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
       $(".pets_gallery").removeClass("hide");
    $(".travel").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_nature_travel").addClass("hide");
  });

  
   /*pets gallery*/
  $(document).on("click", ".pets_gallery", function () {
      $(this).addClass("hide");
     $(".animal_gallery").addClass("hide");
    $(".line_gallery").addClass("hide");
    $(".sports_gallery").addClass("hide");
    $(".nature_gallery").addClass("hide");
        $(".weekend_gallery").addClass("hide");
$(".family_gallery").addClass("hide");
     $(".travel_gallery").addClass("hide");
     $(".back_logo").addClass("hide");
     $(".back_logo").css("display", "none");
     $(".back_pets").removeClass("hide");
    $(".pets").removeClass("hide");
    $('.pets_dogs').removeClass("hide");
     $('.pets_cats').removeClass("hide");
     $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");

  });
   $(document).on("click", ".back_pets.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
         $(".weekend_gallery").removeClass("hide");
$(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
    $(".pets").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".pets_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_pets").addClass("hide");
     $('.pets_dogs').addClass("hide");
     $('.pets_cats').addClass("hide");
  });
  /* pets dogs*/
  $(document).on("click", ".pets_dogs", function () {
    $(this).addClass("hide");
    $(".pets_cats").addClass("hide");
    $('.back_pets').addClass('hide');
   $('.back_dog').removeClass('hide');
   $('.dogs').removeClass('hide');
       $('.dogs .logos_content').removeAttr('style');
       $('.dogs .logo_gallery').removeAttr('style');
     
                 
  });
  $(document).on("click", ".back_dog.back_inner", function () {
    $(this).addClass("hide");
    $('.back_pets').removeClass('hide');
    $('.dogs').addClass('hide');
     $(".pets_cats").removeClass("hide");
     $(".pets_dogs").removeClass("hide");
  });

    /* cats dogs*/
  $(document).on("click", ".pets_cats", function () {
    $(this).addClass("hide");
    $(".pets_dogs").addClass("hide");
    $('.back_pets').addClass('hide');
   $('.back_cats').removeClass('hide');
   $('.cats').removeClass('hide');
    $('.cats .logos_content').removeAttr('style');
       $('.cats .logo_gallery').removeAttr('style');
  });
  $(document).on("click", ".back_cats.back_inner", function () {
    $(this).addClass("hide");
    $('.back_pets').removeClass('hide');
    $('.cats').addClass('hide');
     $(".pets_cats").removeClass("hide");
     $(".pets_dogs").removeClass("hide");
  });

  /*
   * outer fathersday
   */

  $(document).on('click','.customize-item.outerline_gallery',function(){ 
    $('.outerinner_logo_designs_content').addClass('active');
    $('.outerline').removeClass('hide');
    $('.customize-selection').addClass('hide');
  });


    $(document).on("click", ".back_outer.back_btn", function () {
    $(".outerinner_logo_designs_content").removeClass("active");
    $(".customize-selection").removeClass("hide");
   
    $(".outerline").addClass("hide");
    $(".addtocart_box").addClass("hide");
  });

  /* family gallery*/
$(document).on("click", ".inner_gallerry_wraper.family_gallery", function () {
    $(this).addClass("hide");
    $(".animal_gallery").addClass("hide");
   $(".line_gallery").addClass("hide");
    $(".sports_gallery").addClass("hide");
    $(".travel_gallery").addClass("hide");
    $(".pets_gallery").addClass("hide");
  $(".nature_gallery").addClass("hide");
  $(".weekend_gallery").addClass("hide");
    $(".family").removeClass("hide");
    $(".back_logo").addClass("hide");
    $(".back_logo").css("display", "none");
    $(".back_family").removeClass("hide");
    $(".family .logos_content").css("display", "block");
    $(".family .logo_gallery").css("display", "block");
    $(".addtocart_box").addClass("hide");
    $(".gallery_nav_design .clear_btn").removeClass("hide");
    $(".gallery_nav_design .preview_btn").removeClass("hide");
  });
    $(document).on("click", ".back_family.back_inner", function () {
    $(this).addClass("hide");
    $(".animal_gallery").removeClass("hide");
    $(".line_gallery").removeClass("hide");
    $(".nature_gallery").removeClass("hide");
    $(".weekend_gallery").removeClass("hide");
    $(".family_gallery").removeClass("hide");
    $(".travel_gallery").removeClass("hide");
      $(".pets_gallery").removeClass("hide");
    $(".family").addClass("hide");
    $(".sports_gallery").removeClass("hide");
    $(".back_logo").removeClass("hide");
    $(".back_logo").css("display", "flex");
    $(".back_family").addClass("hide");
  });
  
});
